module.exports = __webpack_public_path__ + "static/img/3.1fbce46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/3.png
// module id = l6RN
// module chunks = 1